import { indexFingerCover } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerCoverOrPad/indexFingerCover'
import { middleFingerCover } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerCoverOrPad/middleFIngerCover'
import { State } from 'src/types'

export const fingerGuardDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isIndexFingerCover =
    state.fingerGuardType?.value == 'indexCover' || (state.fingerGuardType?.value === 'unselected' && state.baseModel.position === 'pitcher')
  const isMiddleFingerCover = state.fingerGuardType?.value === 'middleCover'

  // 指カバー
  isIndexFingerCover && indexFingerCover(ctx, state.indexCover.color, state.stitch.color)
  // 指カバー(中指)
  isMiddleFingerCover && middleFingerCover(ctx, state.indexCover.color, state.stitch.color, -140, 65, -10)
}
